module.exports = __webpack_public_path__ + "static/media/riskpic2@2x.9f1785a5.png";